import { Controller } from "@hotwired/stimulus"
import { celebrate } from "../utils/fun_celebrate"
import {
  FUN_SETTINGS_EVENT,
  readFunSettings,
  readFunSkin,
  writeFunSettings,
  writeFunSkin
} from "../utils/fun_settings"

// Les réglages du mode fun, rendus dans la salle d'arcade : trois interrupteurs et le choix du
// skin.
//
// Le serveur rend les cases COCHÉES et le skin « Classique » sélectionné, et c'est ce contrôleur
// qui corrige au `connect()` : le réglage vit dans le navigateur (cf. utils/fun_settings.js), le
// serveur ne peut donc pas le connaître au moment du rendu. L'inverse — rendre tout décoché puis
// cocher — ferait clignoter le panneau.
export default class extends Controller {
  static targets = ["switch", "skin"]

  connect() {
    this.reflect()

    this.onSettings = () => this.reflect()
    window.addEventListener(FUN_SETTINGS_EVENT, this.onSettings)
  }

  disconnect() {
    window.removeEventListener(FUN_SETTINGS_EVENT, this.onSettings)
  }

  reflect() {
    const settings = readFunSettings()
    this.switchTargets.forEach((input) => {
      input.checked = settings[input.dataset.funSwitch] !== false
    })

    const skin = readFunSkin() || "classic"
    this.skinTargets.forEach((input) => {
      input.checked = input.value === skin
    })
  }

  toggle(event) {
    const input = event.currentTarget
    const key = input.dataset.funSwitch
    if (!key) return

    writeFunSettings({ [key]: input.checked })

    // Rallumer les confettis les déclenche : un réglage qu'on ne voit pas agir est un réglage
    // qu'on ne croit pas.
    if (key === "confetti" && input.checked) celebrate("burst")
  }

  pickSkin(event) {
    const input = event.currentTarget
    if (!input.checked) return

    writeFunSkin(input.value === "classic" ? null : input.value)
  }
}
